export default __webpack_public_path__ + "static/media/Q05_澆淋在裝滿冰塊的玻璃杯，冰塊清脆碎裂.f87a8c14.mp4";